module.exports = __webpack_public_path__ + "static/media/logo-fuse.c4cd3a6d.jpg";